import styles from './LoadingIndicator.module.scss';

const LoadingIndicator = () => {
  return <div className={styles.loading}></div>;
};

export default LoadingIndicator;
